module.exports = __webpack_public_path__ + "static/media/teacher-comp-banner-x1.e7f82f97.jpg";